import { Injectable } from '@nestjs/common';
import { WorkstationCategories } from '../workstation-category.entity';
import { WorkstationCategoryDTO } from './workstation-category.dto';

@Injectable()
export class WorkstationCategoryAdapter {
  /**
   * 
   * @param workstationCategoryDTO 
   * @param isUpdate 
   * @returns WorkstationCategories entity
   */
  public convertDtoToEntity(  workstationCategoryDTO: WorkstationCategoryDTO,  isUpdate: boolean = false ): WorkstationCategories {
    const workstationCategory = new WorkstationCategories();
    workstationCategory.workstationCategoryId=workstationCategoryDTO.workstationCategoryId;
    workstationCategory.workstationCategory=workstationCategoryDTO.workstationCategory;
    workstationCategory.isActive=workstationCategoryDTO.isActive==undefined?true:workstationCategoryDTO.isActive;
    if (isUpdate) {
        workstationCategory.updatedUser = workstationCategoryDTO.updatedUser;
    } else {
        workstationCategory.isActive = true;
        workstationCategory.createdUser = workstationCategoryDTO.createdUser;
    }
   return workstationCategory;
  }
  /**
   * 
   * @param workstationCategoryObject WorkstationCategories
   * @returns WorkstationCategoryDTO
   */
  public convertEntityToDto(workstationCategoryObject: WorkstationCategories): WorkstationCategoryDTO {
    const workstationCategoryDTO = new WorkstationCategoryDTO;
    workstationCategoryDTO.workstationCategoryId = workstationCategoryObject.workstationCategoryId;
    workstationCategoryDTO.workstationCategory = workstationCategoryObject.workstationCategory;
    workstationCategoryDTO.isActive = workstationCategoryObject.isActive;
    workstationCategoryDTO.createdAt = workstationCategoryObject.createdAt;
    workstationCategoryDTO.updatedAt = workstationCategoryObject.updatedAt;
    workstationCategoryDTO.createdUser = workstationCategoryObject.createdUser;
    workstationCategoryDTO.updatedUser = workstationCategoryObject.updatedUser;
    workstationCategoryDTO.versionFlag = workstationCategoryObject.versionFlag;
    return workstationCategoryDTO;
  }
}
